import { useIdentity } from "base/identity-resolver";
import { useState, useEffect } from "react";
import { getUserContactIdForOrg } from "apps/journeys/utils/helpers";
import {
  getContactIdsForSection,
  createRecommendedActionsForContacts,
  getRecommendedActionsForSection,
} from "apps/journeys/utils/api-requests/hooks/recommended-actions/use-recommended-actions-requests";
import ErrorLogger from "entities/helpers/error-log-helper";

const useRecommendedActions = (section, enabled) => {
  const [loading, setLoading] = useState(false);
  const [recommendedActions, setRecommendedActions] = useState([]);
  const { user, org } = useIdentity();

  useEffect(() => {
    const getAndSetDataForSection = async () => {
      if (!enabled) return; // Do not fetch data if the section is not enabled.

      try {
        const userSolicitorContactId = Number(getUserContactIdForOrg(user, org));
        if (!userSolicitorContactId || !section) return;
        setLoading(true);
        // STEP 1: Fetch the recommended actions for the section.
        const existingRecommendedActions = await getRecommendedActionsForSection(section);
        // STEP 2: Fetch Contact IDs for contacts that meet the section criteria.
        const contactIds = await getContactIdsForSection(section, userSolicitorContactId);
        // STEP 3: Attempt to create a recommended action for each contact. If one already exists, it will not create a duplicate
        const newlyCreatedRecommendedActions = await createRecommendedActionsForContacts(
          contactIds,
          section,
          existingRecommendedActions
        );

        setRecommendedActions([...newlyCreatedRecommendedActions, ...existingRecommendedActions]);
      } catch (e) {
        ErrorLogger.error(`Error in fetching Recommended Actions for ${section} section.`, {
          extra: { error: e, page_name: "home_page" },
        });
      } finally {
        setLoading(false);
      }
    };

    getAndSetDataForSection();
  }, [org, user, section, enabled]);

  return {
    loading,
    recommendedActions,
  };
};

export default useRecommendedActions;
